(function () {
  function slugify(value) {
    return (value || '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function buildToc(root) {
    var articleBody = root.querySelector('[data-docs-article-body]');
    var tocList = root.querySelector('[data-docs-toc-list]');
    var tocPanel = root.querySelector('[data-docs-toc-panel]');

    if (!articleBody || !tocList || !tocPanel) return;

    var headings = Array.prototype.slice.call(articleBody.querySelectorAll('h2, h3'));

    if (!headings.length) {
      tocPanel.hidden = true;
      return;
    }

    tocList.innerHTML = '';

    headings.forEach(function (heading, index) {
      if (!heading.id) {
        heading.id = slugify(heading.textContent) || 'section-' + (index + 1);
      }

      var link = document.createElement('a');
      link.className =
        'docs-shell__toc-link docs-shell__toc-link--depth-' +
        heading.tagName.replace('H', '');
      link.href = '#' + heading.id;
      link.textContent = heading.textContent;
      link.setAttribute('data-docs-toc-link', heading.id);

      tocList.appendChild(link);
    });

    var tocLinks = Array.prototype.slice.call(
      tocList.querySelectorAll('[data-docs-toc-link]')
    );

    function syncActiveHeading() {
      var activeId = '';

      headings.forEach(function (heading) {
        var rect = heading.getBoundingClientRect();
        if (rect.top <= 140) {
          activeId = heading.id;
        }
      });

      if (!activeId && headings[0]) {
        activeId = headings[0].id;
      }

      tocLinks.forEach(function (link) {
        link.classList.toggle(
          'is-active',
          link.getAttribute('data-docs-toc-link') === activeId
        );
      });
    }

    syncActiveHeading();
    document.addEventListener('scroll', syncActiveHeading, { passive: true });
  }

  function initFilters(root) {
    var inputs = root.querySelectorAll('[data-docs-filter-input]');
    if (!inputs.length) return;

    var navItems = Array.prototype.slice.call(
      root.querySelectorAll('[data-docs-filter-item]')
    );
    var navGroups = Array.prototype.slice.call(
      root.querySelectorAll('[data-docs-filter-group]')
    );
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-docs-card]'));
    var cardGroups = Array.prototype.slice.call(
      root.querySelectorAll('[data-docs-card-group]')
    );
    var emptyState = root.querySelector('[data-docs-filter-empty]');

    function applyFilter(term) {
      var normalized = term.trim().toLowerCase();
      var hasMatches = false;

      navItems.forEach(function (item) {
        var matches = !normalized || item.dataset.docsSearch.indexOf(normalized) !== -1;
        item.hidden = !matches;
      });

      cards.forEach(function (card) {
        var matches = !normalized || card.dataset.docsSearch.indexOf(normalized) !== -1;
        card.hidden = !matches;
        if (matches) hasMatches = true;
      });

      navGroups.forEach(function (group) {
        var visibleLinks = group.querySelectorAll('[data-docs-filter-item]:not([hidden])');
        group.hidden = !visibleLinks.length;
        if (visibleLinks.length) hasMatches = true;
      });

      cardGroups.forEach(function (group) {
        var visibleCards = group.querySelectorAll('[data-docs-card]:not([hidden])');
        group.hidden = !visibleCards.length;
      });

      if (emptyState) {
        emptyState.hidden = hasMatches;
      }
    }

    inputs.forEach(function (input) {
      input.addEventListener('input', function () {
        applyFilter(input.value);
      });
    });
  }

  function initCopyButtons(root) {
    var buttons = root.querySelectorAll('[data-docs-copy-link]');
    if (!buttons.length) return;

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var originalLabel = button.getAttribute('data-copy-label') || button.textContent;
        if (!navigator.clipboard) return;

        navigator.clipboard.writeText(window.location.href).then(function () {
          button.textContent = 'Copied';
          window.setTimeout(function () {
            button.textContent = originalLabel;
          }, 1600);
        });
      });
    });
  }

  function initSidebarToggle(root) {
    var toggle = root.querySelector('[data-docs-sidebar-toggle]');
    var sidebar = root.querySelector('[data-docs-sidebar]');
    if (!toggle || !sidebar) return;

    function syncState(isOpen) {
      sidebar.setAttribute('data-mobile-hidden', isOpen ? 'false' : 'true');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    syncState(window.innerWidth > 989);

    toggle.addEventListener('click', function () {
      var isExpanded = toggle.getAttribute('aria-expanded') === 'true';
      syncState(!isExpanded);
    });

    window.addEventListener('resize', function () {
      syncState(window.innerWidth > 989);
    });
  }

  function initDocsShell(root) {
    initFilters(root);
    initCopyButtons(root);
    initSidebarToggle(root);
    buildToc(root);
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    document.querySelectorAll('[data-docs-shell]').forEach(initDocsShell);
  });
})();
